var _desc, _defs, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 150,
    height: 50,
    viewBox: "0 0 150 50",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 3.5.0")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: "100%",
    height: "100%",
    fill: "rgba(102,51,102,0)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 57 25)",
    style: {},
    id: 455653
  }, /*#__PURE__*/React.createElement("path", {
    xmlSpace: "preserve",
    fontFamily: "Varela Round",
    fontSize: 35,
    fontStyle: "normal",
    fontWeight: "normal",
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(0,0,0) white-space: pre",
      fillRule: "nonzero",
      opacity: 1,
      whiteSpace: "pre"
    },
    d: "M-52.32 11.17Q-52.99 11.17-53.45 10.71Q-53.90 10.26-53.90 9.59L-53.90 9.59L-53.90-5.42Q-53.90-6.09-53.45-6.56Q-52.99-7.03-52.32-7.03L-52.32-7.03Q-51.66-7.03-51.19-6.56Q-50.71-6.09-50.71-5.42L-50.71-5.42L-50.71-3.99Q-49.73-5.39-48.35-6.30Q-46.97-7.21-44.77-7.21L-44.77-7.21Q-42.80-7.21-41.41-6.16Q-40.00-5.11-39.41-3.60L-39.41-3.60Q-37.24-7.21-32.97-7.21L-32.97-7.21Q-31.01-7.21-29.70-6.23Q-28.38-5.25-27.75-3.71Q-27.12-2.17-27.12-0.49L-27.12-0.49L-27.12 9.59Q-27.12 10.26-27.60 10.71Q-28.07 11.17-28.73 11.17L-28.73 11.17Q-29.40 11.17-29.85 10.71Q-30.31 10.26-30.31 9.59L-30.31 9.59L-30.31 0.14Q-30.31-2.13-31.11-3.20Q-31.92-4.27-33.88-4.27L-33.88-4.27Q-35.66-4.27-36.84-3.34Q-38.01-2.41-38.92-0.91L-38.92-0.91L-38.92 9.59Q-38.92 10.26-39.39 10.71Q-39.86 11.17-40.53 11.17L-40.53 11.17Q-41.20 11.17-41.65 10.71Q-42.10 10.26-42.10 9.59L-42.10 9.59L-42.10 0.14Q-42.10-2.13-42.91-3.20Q-43.71-4.27-45.67-4.27L-45.67-4.27Q-47.46-4.27-48.63-3.34Q-49.80-2.41-50.71-0.91L-50.71-0.91L-50.71 9.59Q-50.71 10.26-51.19 10.71Q-51.66 11.17-52.32 11.17L-52.32 11.17ZM-20.19 19.22Q-20.86 19.22-21.31 18.75Q-21.77 18.27-21.77 17.61L-21.77 17.61L-21.77-5.46Q-21.77-6.12-21.31-6.58Q-20.86-7.03-20.19-7.03L-20.19-7.03Q-19.53-7.03-19.06-6.58Q-18.58-6.12-18.58-5.46L-18.58-5.46L-18.58-4.55Q-16.03-7.21-12.60-7.21L-12.60-7.21Q-10.43-7.21-8.49-6.10Q-6.54-5.00-5.34-2.88Q-4.13-0.77-4.13 2.07L-4.13 2.07Q-4.13 4.90-5.34 7.02Q-6.54 9.14-8.49 10.24Q-10.43 11.34-12.60 11.34L-12.60 11.34Q-16.03 11.34-18.58 8.68L-18.58 8.68L-18.58 17.61Q-18.58 18.31-19.04 18.76Q-19.49 19.22-20.19 19.22L-20.19 19.22ZM-13.05 8.37Q-10.46 8.37-8.89 6.72Q-7.31 5.08-7.31 2.07L-7.31 2.07Q-7.31-0.94-8.89-2.59Q-10.46-4.23-13.05-4.23L-13.05-4.23Q-14.66-4.23-16.08-3.51Q-17.50-2.80-18.58-1.61L-18.58-1.61L-18.58 5.74Q-17.50 6.93-16.08 7.65Q-14.66 8.37-13.05 8.37L-13.05 8.37ZM1.89 11.17Q1.23 11.17 0.77 10.71Q0.32 10.26 0.32 9.59L0.32 9.59L0.32-13.12Q0.32-13.79 0.77-14.26Q1.23-14.73 1.89-14.73L1.89-14.73Q2.59-14.73 3.05-14.28Q3.50-13.82 3.50-13.12L3.50-13.12L3.50 9.59Q3.50 10.26 3.03 10.71Q2.56 11.17 1.89 11.17L1.89 11.17ZM31.22 19.22Q30.59 19.22 30.15 18.76Q29.72 18.31 29.72 17.68L29.72 17.68Q29.72 17.40 29.82 17.12L29.82 17.12L32.10 11.27L25.52-4.76Q25.38-5.11 25.38-5.42L25.38-5.42Q25.38-6.09 25.83-6.56Q26.29-7.03 26.95-7.03L26.95-7.03Q27.44-7.03 27.84-6.75Q28.25-6.47 28.42-6.05L28.42-6.05L33.81 7.32L39.31-5.98Q39.76-7.03 40.78-7.03L40.78-7.03Q41.44-7.03 41.90-6.56Q42.35-6.09 42.35-5.42L42.35-5.42Q42.35-5.11 42.25-4.83L42.25-4.83L32.69 18.13Q32.20 19.22 31.22 19.22L31.22 19.22ZM47.60 11.17Q46.94 11.17 46.48 10.71Q46.03 10.26 46.03 9.59L46.03 9.59L46.03-5.42Q46.03-6.09 46.48-6.56Q46.94-7.03 47.60-7.03L47.60-7.03Q48.27-7.03 48.74-6.56Q49.21-6.09 49.21-5.42L49.21-5.42L49.21-3.92Q51.66-7.21 54.71-7.21L54.71-7.21L54.88-7.21Q55.55-7.21 55.98-6.75Q56.42-6.30 56.42-5.63L56.42-5.63Q56.42-4.97 55.97-4.55Q55.51-4.13 54.81-4.13L54.81-4.13L54.64-4.13Q52.96-4.13 51.56-3.30Q50.16-2.48 49.21-1.05L49.21-1.05L49.21 9.59Q49.21 10.26 48.74 10.71Q48.27 11.17 47.60 11.17L47.60 11.17Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 71.763 24.5)",
    style: {},
    id: 594223
  }, /*#__PURE__*/React.createElement("path", {
    xmlSpace: "preserve",
    fontFamily: "Varela Round",
    fontSize: 35,
    fontStyle: "normal",
    fontWeight: "normal",
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(85,187,175)",
      fillRule: "nonzero",
      opacity: 1,
      whiteSpace: "pre"
    },
    d: "M0 11.34Q-2.69 11.34-4.72 10.19Q-6.76 9.03-7.86 6.92Q-8.96 4.80-8.96 2.07L-8.96 2.07Q-8.96-0.66-7.86-2.78Q-6.76-4.90-4.72-6.05Q-2.69-7.21 0-7.21L0-7.21Q2.66-7.21 4.69-6.05Q6.72-4.90 7.84-2.78Q8.96-0.66 8.96 2.07L8.96 2.07Q8.96 4.80 7.84 6.92Q6.72 9.03 4.69 10.19Q2.66 11.34 0 11.34L0 11.34ZM0 8.44Q1.44 8.44 2.75 7.77Q4.06 7.11 4.92 5.67Q5.78 4.24 5.78 2.03L5.78 2.03Q5.78-0.14 4.92-1.57Q4.06-3.01 2.75-3.65Q1.44-4.30 0-4.30L0-4.30Q-1.47-4.30-2.78-3.65Q-4.09-3.01-4.93-1.57Q-5.78-0.14-5.78 2.03L-5.78 2.03Q-5.78 4.24-4.93 5.67Q-4.09 7.11-2.78 7.77Q-1.47 8.44 0 8.44L0 8.44Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.2898 -0.0695 0.0695 0.2898 63.3807 40.5894)",
    id: 502475
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(85,187,175)",
      strokeWidth: 3,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(85,187,175)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-12, -13)",
    d: "M 21.71 3.29 a 1 1 0 0 0 -1.42 0 l -18 18 a 1 1 0 0 0 0 1.42 a 1 1 0 0 0 1.42 0 l 18 -18 A 1 1 0 0 0 21.71 3.29 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.4733 0 0 0.4733 10.9531 10.5114)",
    id: 142201
  }, /*#__PURE__*/React.createElement("circle", {
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(85,187,175)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    cx: 0,
    cy: 0,
    r: 8
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.4733 0 0 0.4733 22.9531 10.5121)",
    id: 667323
  }, /*#__PURE__*/React.createElement("circle", {
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(82,113,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    cx: 0,
    cy: 0,
    r: 8
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.2573 0 0 0.2573 70.2251 28.5003)",
    id: 665003
  }, /*#__PURE__*/React.createElement("circle", {
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    cx: 0,
    cy: 0,
    r: 8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.ced4265b211de8752525319700509124.svg";
export { ForwardRef as ReactComponent };